import { ActionButtonProps } from "./types"
import { StyledActionButton } from "./style";

function ActionButton({
  text,
  action,
  colors
}: ActionButtonProps) {
  

  return (
    <StyledActionButton
      onClick={action}
      colorOne={colors.colorOne}
      colorTwo={colors.colorTwo || colors.colorOne}
      gradientDirection={colors.gradientDirection}
    >
      <span>{text}</span>
    </StyledActionButton>
  );
}

export default ActionButton;
